export V3Check from './V3Check'
export V3FilenamesCheck from './V3FilenamesCheck'
export V3MetaTagsCheck from './V3MetaTagsCheck'
export V3TitleCheck from './V3TitleCheck'
export V3HeadingCheck from './V3HeadingCheck'
export V3ImagesCheck from './V3ImagesCheck'
export V3InternalLinksCheck from './V3InternalLinksCheck'
export V3SubheadingsCheck from './V3SubheadingsCheck'
export V3BlogPostsCheck from './V3BlogPostsCheck'
export V3BlogBacklinksCheck from './V3BlogBacklinksCheck'
export V3ExposesSyndicationCheck from './V3ExposesSyndicationCheck'
export V3BlogPostsTitlesCheck from './V3BlogPostsTitlesCheck'
export V3BlogFrequencyCheck from './V3BlogFrequencyCheck'
export V3BlogOnOwnDomainCheck from './V3BlogOnOwnDomainCheck'
export V3BodyTextCheck from './V3BodyTextCheck'



// WEBPACK FOOTER //
// ./app/components/v3_checks/index.js